import { render } from "./PantryImageZoomPage.vue?vue&type=template&id=4072a5dc&ts=true"
import script from "./PantryImageZoomPage.vue?vue&type=script&lang=ts"
export * from "./PantryImageZoomPage.vue?vue&type=script&lang=ts"

import "./PantryImageZoomPage.vue?vue&type=style&index=0&id=4072a5dc&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__